import React, { useState } from 'react';
import ItemData from '../Model/importItems.json';

function ProductCard({ image, title, onClick }) {
  return (
    <div
      className="w-full bg-white border border-gray-200 rounded-lg shadow-md cursor-pointer"
      onClick={onClick}
    >
      <div>
        <img className="p-8 rounded-t-lg" src={image} alt="product" />
      </div>
      <div className="px-5 pb-5">
        <div>
          <h5 className="text-xl font-semibold tracking-tight text-center text-gray-900">{title}</h5>
        </div>
      </div>
    </div>
  );
}

function ProductCategory({ title, products, onProductClick }) {
  return (
    <div className="my-8">
      <h2 className="mb-6 text-2xl font-bold text-center">{title}</h2>
      <div className="grid max-w-screen-lg grid-cols-2 gap-6 px-5 mx-auto sm:grid-cols-2 lg:grid-cols-4">
        {products.map((product, index) => (
          <ProductCard key={index} {...product} onClick={() => onProductClick(product)} />
        ))}
      </div>
    </div>
  );
}

function ImportItemList() {
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [modalOpen, setModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState(null);

  const products = ItemData.importProducts;
  const categories = ['All', 'Home Appliance', 'Electronic and Electricals', 'Stationeries'];

  const filteredProducts = selectedCategory === 'All'
    ? products
    : products.filter(product => product.category === selectedCategory);

  const openModal = (product) => {
    setModalContent(product);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setModalContent(null);
  };

  return (
    <div className="py-8 bg-white bg-no-repeat bg-cover">
      <div className="flex flex-wrap justify-center mb-6 space-y-2 sm:space-y-0 sm:space-x-4">
        {categories.map(category => (
          <button
            key={category}
            className={`px-4 py-2 mx-2 text-white rounded ${selectedCategory === category ? 'bg-blue-600' : 'bg-gray-600'}`}
            onClick={() => setSelectedCategory(category)}
          >
            {category}
          </button>
        ))}
      </div>
      {selectedCategory === 'All' ? (
        <>
          <ProductCategory title="Home Appliance" products={products.filter(product => product.category === 'Home Appliance')} onProductClick={openModal} />
          <ProductCategory title="Electronic and Electricals" products={products.filter(product => product.category === 'Electronic and Electricals')} onProductClick={openModal} />
          <ProductCategory title="Stationeries" products={products.filter(product => product.category === 'Stationeries')} onProductClick={openModal} />
        </>
      ) : (
        <ProductCategory title={selectedCategory} products={filteredProducts} onProductClick={openModal} />
      )}
      {modalOpen && modalContent && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="relative w-[500px] h-[500px] p-8 bg-white rounded-lg shadow-lg">
            <button onClick={closeModal} className="absolute text-2xl font-bold top-2 right-2">&times;</button>
            <img src={modalContent.image} alt={modalContent.title} className="object-cover w-full h-full" />
          </div>
        </div>
      )}
    </div>
  );
}

export default ImportItemList;
